"use client";

import React from 'react';
import { Button } from '@/components/ui/button';
import { CustomImage } from '@/components/ui/image';

import { TypographyH2 } from '@/components/ui/typography';

interface HomeWhyTrakProps {
    title: string;
    features: string[];
    imageSrc: string;
    ctaText: string;
    ctaHref: string;
}

export function HomeWhyTrakDark({ title, features, imageSrc, ctaText, ctaHref }: HomeWhyTrakProps) {
    return (
        <div className="bg-[#424e54] relative overflow-hidden w-full">
            <div className="grid md:grid-cols-2 gap-0">
                {/* Image - Left Side */}
                <div className="relative min-h-[400px] h-full">
                    <CustomImage
                        src={imageSrc}
                        alt="Why TRAK"
                        fill
                        className="w-full h-full object-cover"
                        containerClassName="w-full h-full"
                        withBackground={false}
                        rounded={false}
                    />
                    {/* Shadow overlay to blend image with dark bg */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#424e54]/50 md:to-[#424e54]" />
                </div>

                {/* Content - Right Side */}
                <div className="p-8 md:p-12 lg:p-16 text-white flex flex-col justify-center">
                    <TypographyH2 className="text-3xl md:text-4xl lg:text-[40px] font-medium text-secondary mb-8">
                        {title}
                    </TypographyH2>

                    <ul className="space-y-4 mb-10">
                        {features.map((feature, index) => (
                            <li key={index} className="flex items-start gap-3 text-gray-300 text-sm md:text-base leading-relaxed">
                                <span className="text-[#391c5a] mt-[2px] text-xl px-1">•</span>
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="flex justify-end">
                        <Button
                            className="bg-secondary text-white text-sm md:text-base lg:text-[16px] h-[40px] rounded-[5px] hover:bg-secondary/90 px-6 uppercase tracking-wide font-bold"
                            asChild
                        >
                            <a href={ctaHref} className="flex items-center gap-2">
                                {ctaText}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-4 h-4 ml-1"
                                >
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
